import { ReactNode } from 'react'

export default function DrillTopicGridLayout({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}): React.ReactElement {
  const mobileGridCols = 'grid-cols-[repeat(3,82px)]'
  const tabletGridCols = 'md:grid-cols-[repeat(8,82px)]'
  const desktopGridCols = 'xl:grid-cols-[repeat(11,82px)]'
  const gridCols = [mobileGridCols, tabletGridCols, desktopGridCols].join(' ')

  return <div className={`z-10 w-max xl:w-auto mx-auto grid ${gridCols} ${className}`}>{children}</div>
}
